import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const PendingRequestsBadge = styled(Box).attrs({
  borderRadius: '50%',
  bg: 'primaryBase',
  color: 'background',
  height: 16,
  width: 16,
  ml: '5px',
  justify: 'center',
})`
  font-size: 10px;
`;
